sessionStorage.setItem('cart-data', JSON.stringify({}));
sessionStorage.removeItem('cartChanged');

if (window.analytics && window.analytics.subscribe) {
	window.analytics.subscribe('product_added_to_cart', handleCartChange);
	window.analytics.subscribe('product_removed_from_cart', handleCartChange);
	window.analytics.subscribe('cart_viewed', handleCartChange);
} else {
	console.warn('analytics is not defined on this page');
}
document.addEventListener('rebuy:cart.add', async (event) => {
	if(event) {
    console.log(
      "%c event ",
      "color: white; background-color: #007acc; border-radius: 4px; font-weight: bold;",
      event
    );
		sessionStorage.setItem('cartChanged', 'true');
	}
});

document.addEventListener('octane.quiz.addToCart', async function (e) {
	const detail = e.detail

	if(detail.items.length > 0) {
		sessionStorage.setItem('cartChanged', 'true');
		handleCartChange(detail)
	}
}, false);

function handleCartChange(event){
	class CheckAndFixedCart {
		constructor() {
			this.cart = JSON.parse(sessionStorage.getItem('cart-data'));
			this.drawer = document.querySelector('cart-drawer-items');
			this.drawerParent = document.querySelector('cart-drawer');

		}

        async init(event) {
            try {
                if (event && window.customAddToCart) {
                    const cart = await window.customAddToCart.getCart();

                    if (cart) {
                        this.updateCartData(cart);

                        const gift_check = await window.customAddToCart.gift_check(this.cart);
                        if (gift_check) {
                            const load = await this.giftCartCheck();

                            if (load) {
                                this.updateBubble();
                            }
                        }
                    }
                }

                const isCartPage = document.querySelector('body[data-template="cart"]') !== null;

                async function insertCartPageContent() {
                    document.body.classList.add('cart-page-refreshing');

                    try {
                        const parser = new DOMParser();
                        const res_page_cart = await fetch('/cart');
                        if (!res_page_cart.ok) throw new Error(`Cart page refresh failed: HTTP ${res_page_cart.status}`);

                        const html_cart = await res_page_cart.text();
                        const newDocCart = parser.parseFromString(html_cart, 'text/html');

                        if (newDocCart) {
                            const newTest = newDocCart.querySelector('cart-items');
                            const oldPageCart = document.querySelector('cart-items');
                            const checkout = document.getElementById('checkout');

                            const cartTotal = newDocCart.querySelector('#MainContent .cart__footer');
                            const cartTotalIncluded = document.querySelector('#MainContent .cart__footer');

                            if (oldPageCart && newTest) {
                                oldPageCart.innerHTML = newTest.innerHTML;
                                oldPageCart.classList.remove('is-empty');

                                if (cartTotalIncluded && cartTotal) {
                                    cartTotalIncluded.innerHTML = cartTotal.innerHTML;
                                }

                                if (checkout) {
                                    checkout.disabled = false;
                                }

                                const cartGeneration = window.customAddToCart.cartStateGeneration;
                                const cart = await window.customAddToCart.getCart();

                                await window.customAddToCart.giftLineInit(cart.total_price, false, cart, cartGeneration);

                                window.scrollTo(0, 0);
                            }

                            setTimeout(() => {
                                window.prescriptionModal.init();
                            }, 0);
                        }
                    } catch (error) {
                        console.error('Cart page refresh error:', error);
                    } finally {
                        setTimeout(() => {
                            document.body.classList.remove('cart-page-refreshing');
                        }, 150);
                    }
                }

                if (isCartPage) {
                    await insertCartPageContent();
                } else {
                    setTimeout(insertCartPageContent, 20);
                }

            } catch (error) {
                console.error('Cart init error:', error);
            }
        }

		insertItemsLength() {
			this.cart.count = this.cart.items.reduce((sum, item) => sum + item.quantity, 0);
		}

		updateCartData(event) {
			const totalPrice = event.total_price
				? event.total_price
				: event.items.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);

			this.cart = {
				items: [...event.items],
				total_price: totalPrice
			};

			sessionStorage.setItem('cart-data', JSON.stringify(this.cart));
		}

		updateCartTotal(event) {
			const openModal = event.properties._source === "Rebuy";
			if(openModal) {
				sessionStorage.setItem('cartChanged', 'true');
			}

			const index = this.cart.items.findIndex(item => item.id === event.id);


			if (index !== -1) {
				this.cart.items[index] = event;
			} else {
				this.cart.items.push(event);
			}

			this.cart.total_price = this.cart.items.reduce((sum, item) => {
				return sum + item.final_line_price;
			}, 0);

			sessionStorage.setItem('cart-data', JSON.stringify(this.cart))
		}

		updateBubble() {
			this.insertItemsLength();
			const bubbleParent = document.querySelector('#cart-icon-bubble');
			const bubble = document.querySelector('.cart-count-bubble [aria-hidden="true"]');
			const drawerBubbles = document.querySelectorAll('.drawer__heading .total_items');

			if(this.cart.items.length !== 0) {
				if(!bubble) {
					const parent = document.createElement('div');
					const bubble = document.createElement('span');
					bubble.textContent = this.cart.count;
					parent.classList.add('cart-count-bubble');
					parent.appendChild(bubble);
					bubbleParent.appendChild(parent);
				} else {
					bubble.textContent = this.cart.count
				}
				drawerBubbles.forEach(bubble => bubble.textContent = `(${this.cart.count})`);
			} else {
        const bubbles = document.querySelectorAll('.cart-count-bubble');
        if (bubbles.length > 0) {
          bubbles.forEach(bubble => {
            bubble.remove();
          });
        }
      }
		}

		async giftCartCheck() {
      const template = document.querySelector('body[data-template]');

      const drawerOpen = sessionStorage.getItem('cartChanged');
      const res = await fetch('/?section_id=cart-drawer');
      if (!res.ok) throw new Error(`Cart drawer refresh failed: HTTP ${res.status}`);
      const html = await res.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');

      const newDrawer = newDoc.querySelector('#CartDrawer');
      const drawer = document.querySelector('cart-drawer');

      const currentDrawer = document.querySelector('#CartDrawer');
      if (currentDrawer && newDrawer) {
        if (currentDrawer.innerHTML !== newDrawer.innerHTML) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          // Sync the drawer's empty state with the swapped markup before paint;
          // the async toggle below runs a network round-trip too late.
          drawer?.classList.toggle('is-empty', !!newDoc.querySelector('cart-drawer-items.is-empty'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(() => {
            if (drawerOpen === 'true') {
              if (template.dataset.template !== 'cart') {
                drawer.open();
              }
              sessionStorage.removeItem('cartChanged');
            }
          }, 20);

            setTimeout(async () => {
                window.cart_drawer_swiper__mobile();

                const template = document.querySelector('body[data-template]');
                const cartGeneration = window.customAddToCart.cartStateGeneration;
                const latestCart = await window.customAddToCart.getCart();
                if (template?.dataset.template !== 'cart' && latestCart) {
                    await window.customAddToCart.giftLineInit(latestCart.total_price, false, latestCart, cartGeneration);
                }

                if (latestCart?.items.length === 0) {
                    this.drawer.classList.add('is-empty');
                    this.drawerParent.classList.add('is-empty');
                }
            }, 40);

          setTimeout(() => {
            window.prescriptionModal.init();
          }, 2000);
        }
      }

      return true;
    }

	}

	new CheckAndFixedCart().init(event);
}
